module.exports = __webpack_public_path__ + "static/media/HEART-6.4efaf324.svg";